export default __webpack_public_path__ + "static/media/harmonylogo_min.32a1b8d0.png";